import { SvgIcon, SvgIconProps } from "@material-ui/core";
import React, { CSSProperties } from "react";

export function ViewIcon(props: SvgIconProps) {
  const st0: CSSProperties = {
    fill: "none",
    stroke: "currentcolor",
    strokeWidth: 1.463,
    strokeMiterlimit: 10,
  };
  const st1: CSSProperties = {
    fill: "none",
    stroke: "currentcolor",
    strokeMiterlimit: 10,
  };

  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <path
        style={st0}
        d="M21.71,8.84c-0.42-0.49-0.9-0.97-1.43-1.38c-0.53-0.43-1.1-0.81-1.73-1.14c-0.62-0.34-1.29-0.63-1.99-0.87
	c-0.7-0.24-1.43-0.42-2.19-0.55c-0.76-0.12-1.55-0.19-2.36-0.19c-0.81,0-1.6,0.07-2.36,0.19C8.9,5.02,8.16,5.2,7.47,5.44
	C6.76,5.67,6.1,5.97,5.48,6.31C4.86,6.64,4.27,7.03,3.74,7.45s-1,0.89-1.43,1.38c-0.43,0.49-0.78,1.03-1.08,1.59
	c0.3,0.56,0.66,1.1,1.08,1.59c0.42,0.49,0.9,0.97,1.43,1.38c0.53,0.43,1.1,0.81,1.73,1.14c0.62,0.34,1.29,0.63,1.99,0.87
	c0.7,0.24,1.43,0.42,2.19,0.55c0.76,0.12,1.55,0.19,2.36,0.19c0.81,0,1.6-0.07,2.36-0.19c0.76-0.12,1.49-0.31,2.19-0.55
	c0.7-0.24,1.36-0.53,1.99-0.87c0.62-0.34,1.2-0.73,1.73-1.14s1.01-0.89,1.43-1.38c0.42-0.49,0.78-1.03,1.08-1.59
	C22.49,9.87,22.13,9.34,21.71,8.84z"
      />
      <circle style={st1} cx="11.98" cy="10.43" r="4.5" />
      <path
        d="M11.98,7.81c-1.38,0-2.49,1.11-2.49,2.49s1.11,2.49,2.49,2.49s2.49-1.11,2.49-2.49C14.47,8.93,13.35,7.81,11.98,7.81z
	 M12.88,9.86c-0.34,0-0.61-0.27-0.61-0.61s0.27-0.61,0.61-0.61s0.61,0.27,0.61,0.61S13.22,9.86,12.88,9.86z"
      />
    </SvgIcon>
  );
}
